<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2251_221)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 5C2.39543 5 1.5 5.89543 1.5 7V15C1.5 16.1046 2.39543 17 3.5 17H18.5C19.6046 17 20.5 16.1046 20.5 15V7C20.5 5.89543 19.6046 5 18.5 5H3.5ZM8.03792 10.3C7.65132 10.3 7.33792 10.6134 7.33792 11C7.33792 11.3866 7.65132 11.7 8.03792 11.7H13.9621C14.3487 11.7 14.6621 11.3866 14.6621 11C14.6621 10.6134 14.3487 10.3 13.9621 10.3H8.03792Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2251_221">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
